module.exports = __webpack_public_path__ + "static/media/14UNEP17.ccf8224d.jpg";